/* ===========================================================================
   Natfy — el javascript del tema, entero.
   ---------------------------------------------------------------------------
   Va con `defer`, asi que el DOM ya esta cuando se ejecuta. No hay framework,
   no hay build step y no hay dependencias: son unos pocos kilobytes.

   REGLA DE FONDO: si algo se puede hacer con Liquid, CSS o <details>, no se
   hace aqui. Los acordeones de la ficha son <details> nativos, la rejilla es
   CSS y la paginacion son enlaces de verdad. Lo que queda aqui es lo que de
   verdad necesita javascript: elegir variante, mover la galeria, abrir el menu
   y abrir el panel de filtros.

   Y la segunda regla, que es de rendimiento (INP): nada de trabajo en bucle,
   nada de observadores caros y ni un solo listener por elemento donde sirva uno
   delegado en el documento.
   ======================================================================== */

(function () {
  'use strict';

  var $  = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };

  /* --- Menu movil ------------------------------------------------------ */

  var panel = $('#n-panel-menu');

  function abreMenu(abierto) {
    if (!panel) return;
    panel.hidden = !abierto;
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
    var boton = $('[data-abre-menu]');
    if (boton) boton.setAttribute('aria-expanded', String(abierto));
    // El foco se lleva al panel al abrir y se devuelve al boton al cerrar. Sin
    // esto, quien navega con teclado sigue en la cabecera mientras el panel
    // tapa la pagina entera.
    if (abierto) {
      var primero = panel.querySelector('button, a');
      if (primero) primero.focus();
    } else if (boton) {
      boton.focus();
    }
  }

  /* --- Panel de filtros ------------------------------------------------ */

  var filtros = $('[data-filtros]');
  var velo = $('[data-velo]');

  function abreFiltros(abierto) {
    if (!filtros) return;
    // En escritorio la columna de filtros es parte de la pagina y no se
    // esconde nunca: el panel deslizante es solo el comportamiento movil.
    if (window.matchMedia('(min-width: 990px)').matches) return;
    // Atributo y no `hidden`: el estado de reposo lo pone el CSS, para que el
    // panel no tape la coleccion mientras el script no se ha ejecutado.
    if (abierto) filtros.setAttribute('data-abierto', '');
    else filtros.removeAttribute('data-abierto');
    if (velo) velo.hidden = !abierto;
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
  }

  /* --- Delegacion unica ------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cierra-mini]')) { abreCajon(false); return; }
    if (t.closest('[data-abre-menu]')) { abreMenu(true); return; }
    if (t.closest('[data-cierra-menu]')) { abreMenu(false); return; }
    if (t.closest('[data-abre-filtros]')) { abreFiltros(true); return; }
    if (t.closest('[data-cierra-filtros]') || t.closest('[data-velo]')) { abreFiltros(false); return; }

    // Acordeon del menu movil. Un solo nivel, como pide el traspaso de diseno.
    var acordeon = t.closest('[data-acordeon]');
    if (acordeon) {
      var abierto = acordeon.getAttribute('aria-expanded') === 'true';
      acordeon.setAttribute('aria-expanded', String(!abierto));
      var sub = acordeon.nextElementSibling;
      if (sub) sub.hidden = abierto;
      return;
    }

    // Galeria: la miniatura cambia la foto grande sin recargar nada.
    var tira = t.closest('[data-galeria-tira]');
    if (tira) {
      e.preventDefault();
      pintaFoto(tira.getAttribute('data-galeria-tira'));
      return;
    }

    // Flechas sobre la foto grande. Pasan a la siguiente y dan la vuelta al
    // llegar al final: en una galeria de cinco fotos, encontrarse la flecha
    // muerta es peor que volver a la primera.
    var paso = t.closest('[data-galeria-paso]');
    if (paso) {
      var botones = $$('[data-galeria-tira]');
      if (!botones.length) return;
      var actual = botones.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
      if (actual < 0) actual = 0;
      var salto = parseInt(paso.getAttribute('data-galeria-paso'), 10);
      var siguiente = (actual + salto + botones.length) % botones.length;
      pintaFoto(botones[siguiente].getAttribute('data-galeria-tira'));
      return;
    }

    // Cantidad
    var paso = t.closest('[data-cantidad]');
    if (paso) {
      var campo = $('#n-cantidad');
      if (campo) {
        var n = parseInt(campo.value, 10) || 1;
        n = paso.getAttribute('data-cantidad') === 'mas' ? n + 1 : Math.max(1, n - 1);
        campo.value = n;
      }
      return;
    }

    // Copiar el EAN. La confianza de esta ficha se apoya en que el dato se
    // pueda comprobar FUERA de la tienda, y para eso hay que poder llevarselo.
    var copia = t.closest('[data-copiar]');
    if (copia) {
      var valor = copia.getAttribute('data-copiar');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(valor).then(function () {
          var antes = copia.textContent;
          copia.textContent = 'copiado';
          setTimeout(function () { copia.textContent = antes; }, 1600);
        });
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cajon && !cajon.hidden) abreCajon(false);
    if (panel && !panel.hidden) abreMenu(false);
    if (filtros && filtros.hasAttribute('data-abierto')) abreFiltros(false);
  });

  /* --- Galeria --------------------------------------------------------- */

  var principal = $('[data-galeria-principal]');

  function pintaFoto(idMedia) {
    if (!principal || !idMedia) return;
    var origen = $('[data-galeria-tira="' + idMedia + '"] img');
    var destino = principal.querySelector('img');
    if (!origen || !destino) return;
    // Se copian src, srcset y alt de la miniatura: la imagen grande ya esta en
    // la cache del navegador con otro ancho del mismo srcset, asi que el cambio
    // es inmediato y no dispara una peticion nueva.
    destino.src = origen.getAttribute('data-grande') || origen.src;
    destino.srcset = origen.getAttribute('data-grande-srcset') || '';
    destino.alt = origen.alt;
    $$('[data-galeria-tira]').forEach(function (b) {
      b.setAttribute('aria-current', String(b.getAttribute('data-galeria-tira') === idMedia));
    });
  }

  /* --- Buscador predictivo ----------------------------------------------- */

  // El HTML lo pinta la seccion `buscar-sugerencias` en el servidor. Aqui solo
  // se pide y se mete: ni plantillas en el cliente, ni formateo de precios
  // repetido, ni una segunda version de la tarjeta que se desincronice.
  var buscador = $('[data-buscador]');
  if (buscador) {
    var campo = $('.n-buscar__campo', buscador);
    // `sugerencias` y NO `panel`: con var, redeclarar `panel` aqui pisaba el
    // del menu movil en toda la funcion y la hamburguesa dejaba de abrir nada.
    var sugerencias = $('[data-sugerencias]', buscador);
    var reloj = null;
    var ultimaBusqueda = '';
    var enVuelo = null;

    var muestra = function (abierto) {
      sugerencias.hidden = !abierto;
      campo.setAttribute('aria-expanded', String(abierto));
    };

    var pide = function (q) {
      if (enVuelo) enVuelo.abort();
      enVuelo = new AbortController();
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,query&resources[limit]=6' +
        '&section_id=buscar-sugerencias';
      fetch(url, { signal: enVuelo.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var trozo = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          sugerencias.innerHTML = trozo ? trozo.innerHTML : html;
          muestra(true);
        })
        // Si falla, el panel se cierra y el formulario sigue funcionando: darle
        // al intro lleva a /search de toda la vida.
        .catch(function (e) { if (e.name !== 'AbortError') muestra(false); });
    };

    campo.addEventListener('input', function () {
      var q = campo.value.trim();
      clearTimeout(reloj);
      if (q.length < 2) { muestra(false); return; }
      if (q === ultimaBusqueda) return;
      // 250 ms: por debajo se dispara una peticion por tecla y el servidor
      // devuelve resultados de una palabra a medio escribir.
      reloj = setTimeout(function () { ultimaBusqueda = q; pide(q); }, 250);
    });

    campo.addEventListener('focus', function () {
      if (sugerencias.innerHTML.trim() && campo.value.trim().length > 1) muestra(true);
    });

    document.addEventListener('click', function (e) {
      if (!buscador.contains(e.target)) muestra(false);
    });

    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { muestra(false); campo.blur(); }
    });
  }

  /* --- Mini-carrito ----------------------------------------------------- */

  // El marcado del cajon lo pinta el SERVIDOR: se pide la seccion `mini-cesta`
  // con la Section Rendering API y se sustituye entera. Asi las lineas, el
  // formateo de moneda y la barra de umbral estan escritos una sola vez, en
  // Liquid, y no hay una segunda version en javascript que se desincronice.
  var cajon = $('[data-mini-cesta]');
  var ultimoFoco = null;

  function repintaCajon(html) {
    if (!html) return;
    var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mini-cesta]');
    if (!nuevo || !cajon) return;
    var estaba = !cajon.hidden;
    cajon.innerHTML = nuevo.innerHTML;
    cajon.hidden = !estaba;
  }

  function abreCajon(abierto) {
    if (!cajon) return;
    cajon.hidden = !abierto;
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
    if (abierto) {
      ultimoFoco = document.activeElement;
      // Al añadir, el botón está deshabilitado («Añadiendo…») y el foco cae al
      // body: al cerrar se devolvía a ninguna parte. Se vuelve al botón.
      if (!ultimoFoco || ultimoFoco === document.body) ultimoFoco = $('[data-anadir]');
      // El botón y no el primer [data-cierra-mini]: ese es el velo, un div que
      // no admite foco, y el teclado se quedaba fuera del cajón.
      var primero = cajon.querySelector('button[data-cierra-mini]') || cajon.querySelector('a, button');
      if (primero) primero.focus();
    } else if (ultimoFoco) {
      ultimoFoco.focus();
      ultimoFoco = null;
    }
  }

  function actualizaCuentaCesta(n) {
    $$('.n-cesta__cuenta').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }

  // Se intercepta el envio del formulario de producto. Si algo falla -red,
  // stock que se acaba entre que se carga la pagina y se pulsa- se deja que el
  // formulario siga su camino normal y Shopify lleve a /cart, que es la via de
  // siempre y no depende de nada de esto.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-form-producto]');
    if (!form || !cajon) return;
    e.preventDefault();

    var boton = form.querySelector('[data-anadir]');
    var antes = boton ? boton.innerHTML : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo…'; }

    var datos = new FormData(form);
    datos.append('sections', 'mini-cesta');

    fetch('/cart/add.js', { method: 'POST', body: datos, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'no se pudo añadir');
        if (res.j.sections && res.j.sections['mini-cesta']) repintaCajon(res.j.sections['mini-cesta']);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (carrito) {
        actualizaCuentaCesta(carrito.item_count);
        abreCajon(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (boton) { boton.disabled = false; boton.innerHTML = antes; } });
  });

  /* --- Importes y envío ------------------------------------------------ */

  // Con el MISMO formato que el filtro `money` del servidor, que es un ajuste
  // de la tienda. Si el script pintase «13,90 €» y el servidor «€13,90», el
  // precio cambiaria de aspecto al cambiar de formato.
  var FORMATO = document.documentElement.getAttribute('data-moneda') || '{{amount_with_comma_separator}} €';
  function euros(centimos) {
    return FORMATO.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, clave) {
      var sinDecimales = clave.indexOf('no_decimals') !== -1;
      var coma = clave.indexOf('comma') !== -1 || clave.indexOf('apostrophe') !== -1;
      var partes = (centimos / 100).toFixed(sinDecimales ? 0 : 2).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, coma ? '.' : ',');
      return partes.join(coma ? ',' : '.');
    });
  }

  // Lo que falta para el envio gratis, con la cesta de ahora mas este producto.
  // Mismo calculo que hace el servidor al pintar la ficha.
  function pintaEnvio(precio) {
    var g = $('[data-garantias]');
    if (!g) return;
    var umbral = parseInt(g.getAttribute('data-umbral'), 10) || 0;
    var cesta = parseInt(g.getAttribute('data-cesta'), 10) || 0;
    var falta = umbral - cesta - precio;
    var ok = $('[data-envio-logrado]', g);
    var no = $('[data-envio-falta]', g);
    if (ok) ok.hidden = falta > 0;
    if (no) no.hidden = falta <= 0;
    var cifra = $('[data-envio-cifra]', g);
    if (cifra && falta > 0) cifra.textContent = euros(falta);
  }

  /* --- «También en»: varios productos de una vez ------------------------- */

  function sumaTambien() {
    var total = $('[data-tambien-total]');
    if (!total) return;
    var suma = $$('[data-form-varios] input[type="checkbox"]:checked').reduce(function (a, c) {
      return a + (parseInt(c.getAttribute('data-tambien-precio'), 10) || 0);
    }, 0);
    total.textContent = euros(suma);
    var boton = $('[data-form-varios] button[type="submit"]');
    if (boton) boton.disabled = suma === 0;
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-form-varios]')) sumaTambien();
  });

  // Sin script el formulario va a /cart/add con items[][id] y Shopify lleva a
  // la cesta. Con script se añaden todos en una peticion y se abre el cajon.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-form-varios]');
    if (!form || !cajon) return;
    e.preventDefault();
    var items = $$('input[type="checkbox"]:checked', form).map(function (c) {
      return { id: parseInt(c.value, 10), quantity: 1 };
    });
    if (!items.length) return;
    var boton = $('button[type="submit"]', form);
    var antes = boton ? boton.innerHTML : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'mini-cesta' })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'no se pudo añadir');
        if (res.j.sections && res.j.sections['mini-cesta']) repintaCajon(res.j.sections['mini-cesta']);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (carrito) {
        actualizaCuentaCesta(carrito.item_count);
        abreCajon(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (boton) { boton.disabled = false; boton.innerHTML = antes; } });
  });

  /* --- Variantes -------------------------------------------------------- */

  var datos = $('#n-variantes');
  if (datos) {
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (err) { variantes = null; }

    if (variantes && variantes.length) {
      var formulario = $('[data-form-producto]');

      // Los valores van en la POSICION de su opcion en Shopify, no en el orden
      // en que salen en la pagina. La ficha pinta el Formato primero aunque en
      // Shopify sea la opcion 2, y leerlas por orden del documento comparaba
      // «300g» con el sabor: ninguna variante casaba y se deshabilitaban todas
      // las opciones. Las opciones de un solo valor no tienen radio y se quedan
      // como hueco, que `busca` no compara.
      var elegidas = function () {
        var vals = [];
        $$('[data-opcion]:checked').forEach(function (i) {
          vals[parseInt(i.getAttribute('data-opcion'), 10)] = i.value;
        });
        return vals;
      };

      var busca = function (vals) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var igual = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] === undefined) continue;
            if (v.opciones[j] !== vals[j]) { igual = false; break; }
          }
          if (igual) return v;
        }
        return null;
      };

      var pinta = function (v) {
        // Una combinacion que no existe no deja la ficha con los datos de la
        // anterior: se apaga el boton y se esconden los datos de variante. El
        // EAN identifica el articulo y es lo que el cliente usa para reclamar;
        // enseñar el de otro sabor no es un detalle de maqueta.
        var boton = $('[data-anadir]');
        var id = $('[data-variante-id]');

        $$('[data-natfy-ficha]').forEach(function (b) {
          b.hidden = !v || b.getAttribute('data-natfy-ficha') !== String(v.id);
        });
        var etiquetado = $('[data-etiquetado]');
        if (etiquetado) {
          etiquetado.hidden = !$$('[data-natfy-ficha]').some(function (b) { return !b.hidden; });
        }

        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = 'Combinación no disponible'; }
          $$('[data-campo-variante]').forEach(function (el) {
            var fila = el.closest('.n-verificables__par') || el;
            fila.hidden = true;
          });
          return;
        }

        if (id) id.value = v.id;

        $$('[data-campo-variante]').forEach(function (el) {
          var campo = el.getAttribute('data-campo-variante');
          var valor = v[campo];
          var fila = el.closest('.n-verificables__par') || el;
          if (!valor) { fila.hidden = true; return; }
          fila.hidden = false;
          if (el.textContent !== valor) el.textContent = valor;
          var copiar = fila.querySelector('[data-copiar]');
          if (copiar) copiar.setAttribute('data-copiar', valor);
        });

        $$('[data-precio]').forEach(function (el) {
          el.innerHTML = el.closest('.n-barra-compra') ? v.precio_barra_html : v.precio_html;
        });
        var unitario = $('[data-unitario]');
        if (unitario && v.unitario_html) unitario.innerHTML = v.unitario_html;

        var disp = $('[data-disponibilidad]');
        if (disp) {
          disp.textContent = v.disponible ? 'Disponible' : 'Sin existencias';
          disp.classList.toggle('n-disponible--agotado', !v.disponible);
        }

        // El precio vuelve a la etiqueta del boton. Antes se reescribia solo
        // «Añadir a la cesta» y el importe desaparecia al cambiar de formato.
        if (boton) {
          boton.disabled = !v.disponible;
          boton.innerHTML = v.disponible
            ? 'Añadir a la cesta · <span data-precio-boton>' + euros(v.precio) + '</span>'
            : 'Sin existencias';
        }

        var selloPct = $('[data-sello-descuento]');
        if (selloPct) {
          selloPct.hidden = !(v.descuento > 0);
          var n = $('[data-sello-pct]', selloPct);
          if (n) n.textContent = v.descuento;
        }
        var selloEtq = $('[data-sello-etiquetado]');
        if (selloEtq) selloEtq.hidden = !v.etiquetado;

        $$('[data-solo-disponible]').forEach(function (el) { el.hidden = !v.disponible; });
        pintaEnvio(v.precio);

        var actual = $('[data-tambien-actual]');
        if (actual) {
          actual.value = v.id;
          actual.setAttribute('data-tambien-precio', v.precio);
          var pa = $('[data-tambien-precio-actual]');
          if (pa) pa.textContent = euros(v.precio);
          var tv = $('[data-tambien-variante]');
          if (tv) tv.textContent = v.titulo;
          sumaTambien();
        }

        var barra = $('[data-barra-variante]');
        if (barra) barra.textContent = v.titulo;
        // La barra fija decía «Comprar» también en una variante agotada.
        var barraBoton = $('[data-barra-boton]');
        if (barraBoton) barraBoton.textContent = v.disponible ? 'Comprar' : 'Sin existencias';

        if (v.media_id) pintaFoto(String(v.media_id));

        // La URL cambia con replaceState y no con pushState: cada sabor no es
        // una entrada distinta del historial, y si lo fuera el boton de atras
        // dejaria de salir de la ficha.
        if (window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      };

      // Las combinaciones que no existen con lo elegido se marcan, pero NO se
      // deshabilitan. Deshabilitadas creaban un bloqueo: en la creatina, Neutro
      // solo existe en 500 g y el 500 g solo en Neutro, asi que desde «Ponche de
      // Frutas / 300 g» los dos salian apagados y esa variante no se podia
      // elegir nunca. Al pulsar una marcada se salta a la variante mas cercana
      // que lleva ese valor, mejor si esta disponible.
      var marcaImposibles = function () {
        var vals = elegidas();
        $$('[data-opcion]').forEach(function (radio) {
          var pos = parseInt(radio.getAttribute('data-opcion'), 10);
          var prueba = vals.slice();
          prueba[pos] = radio.value;
          radio.toggleAttribute('data-imposible', !busca(prueba));
        });
      };

      var saltaA = function (pos, valor) {
        var con = variantes.filter(function (v) { return v.opciones[pos] === valor; });
        var mejor = con.filter(function (v) { return v.disponible; })[0] || con[0];
        if (!mejor) return null;
        $$('[data-opcion]').forEach(function (radio) {
          var p = parseInt(radio.getAttribute('data-opcion'), 10);
          radio.checked = mejor.opciones[p] === radio.value;
        });
        return mejor;
      };

      formulario && formulario.addEventListener('change', function (e) {
        if (!e.target.matches('[data-opcion]')) return;
        var v = busca(elegidas());
        if (!v) v = saltaA(parseInt(e.target.getAttribute('data-opcion'), 10), e.target.value);
        marcaImposibles();
        pinta(v);
      });

      marcaImposibles();
    }
  }
})();
